angular.module("ainapp")
    .controller("driverPaymentSheetsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Driver Payment Sheets";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

                $scope.filter = {
                    VoucherNo: "",
                    EmployeeIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                }

                $scope.load = false;
                $scope.isFilter = false;


                $scope.Columns = [{
                        field: "VoucherNumber",
                        title: "Doc No #",
                        width: "120px",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
                    {
                        field: "TotalOrders",
                        title: "Total Orders",
                        width: "100px",
                                            },
                    {
                        field: "TotalAmount",
                        title: "Total Amount",
                        width: "100px",
                                            },
                    {
                        field: "CreatedBy.UserName",
                        title: "Created By",
                        width: "100px",
                                            },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        width: "200px",
                                            },
                    ]

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Driver Payment Sheet").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        if (e.Section == "Head") {
                            var field = e.CostCenter.Name.replace(/ /g, '');
                            field = field.replace('&', '');

                            var clm = {
                                title: e.CostCenter.Name,
                                field: "CC" + field,
                                //  template: "<a ng-repeat='cc in dataItem.SalesInvoiceCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                                width: '100px',
                                //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                            }
                            $scope.Columns.push(clm);
                        }
                    })

                    var opt = {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button>  ",
                        width: '60px'
                    };

                    $scope.Columns.push(opt);

                    $scope.loadKendo1();
                });

            }
            $scope.Init();
            //<button class=' btn-default btn-sm fa fa-print'  ng-click=\"PrintInvoice(dataItem.Id, 'Time Sheet')\"></button>

            $scope.loadKendo1 = function () {
                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            //                            o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                            //                            o.data.FromDay = $scope.filter.FromDate.getDate();
                            //                            o.data.FromYear = $scope.filter.FromDate.getFullYear();
                            //                            o.data.AccountIds = $scope.filter.AccountIds;
                            //
                            //                            o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                            //                            o.data.ToDay = $scope.filter.ToDate.getDate();
                            //                            o.data.ToYear = $scope.filter.ToDate.getFullYear();
                            //
                            //                            o.data.EmployeeIds = $scope.filter.EmployeeIds;

                            MainService.DriverPaymentSheetInView(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })

                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (ee) {

                                angular.forEach(arr, function (ar) {

                                    angular.forEach(ee.TimeSheetCosts, function (a) {

                                        var afield = a.CostCenter.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            ee[ar] = a.CostCenter.Name;
                                        }
                                    })


                                })

                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                "VoucherNumber": {
                                    type: "string",
                                    editable: false,
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                    editable: false,
                                },
                                "Date": {
                                    type: "date",
                                    editable: false,
                                },
                                "TotalAmount": {
                                    type: "number",
                                    editable: false,
                                },
                                "TotalOrders": {
                                    type: "number",
                                    editable: false,
                                },

                                "Remarks": {
                                    type: "string",
                                    editable: false,
                                },
                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                });

                $scope.KendoGridOptions = {


                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: true,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },

                    columns: $scope.Columns,
                };

            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Edit = function (data) {
                $state.go("editDriverPaymentSheet", {
                    VoucherId: data.Id
                })
            };



        }])
